module.exports = __webpack_public_path__ + "img/no_right.cc0cf239.png";